import './Spinner.css';

export interface SpinnerProps {
  size?: number;
  /** Accessible label; pass '' for decorative spinners inside labelled controls. */
  label?: string;
}

export function Spinner({ size = 24, label = 'Loading' }: SpinnerProps) {
  return (
    <span
      className="spinner"
      style={{ width: size, height: size, borderWidth: Math.max(2, Math.round(size / 10)) }}
      role={label ? 'status' : undefined}
      aria-label={label || undefined}
      data-testid="spinner"
    />
  );
}
